import { render, staticRenderFns } from "./DashboardCMCrono.vue?vue&type=template&id=1dc0d2c2&scoped=true&"
import script from "./DashboardCMCrono.vue?vue&type=script&lang=js&"
export * from "./DashboardCMCrono.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dc0d2c2",
  null
  
)

export default component.exports